import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { FileUploader } from "../../../../components/FileUploader";
import {
  GetServiceCaller,
  PostFormServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useParams } from "react-router-dom";
import { Table } from "react-bootstrap";
import { FaSpinner } from "react-icons/fa";
import { PhoneInput } from "react-international-phone";
import * as Yup from "yup";
import DeleteModal from "../../../../components/DeletePopUpComponent";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
const customStyle = {
  control: (provided, state) => ({
    ...provided,
    height: "64px",
    overflow: "scroll",
  }),
  multiValueRemove: (base, state) => ({
    ...base,
    color: "white", // Sets the color of the cancel icon
    ":hover": {
      backgroundColor: "red", // Adjust hover background color if needed
      color: "white", // Adjust hover color here
    },
  }),
};

const AddContractor = () => {
  const { id } = useParams();
  const initialFormData = {
    Title: "",
    FullName: "",
    FirstName: "",
    LastName: "",
    Role: "",
    Gender: '',
    SkillID: [],
    SubSkillID: [],
    Phone: "",
    Email: "",
    RomPoc: "",
    TotalExp: "",
    RelevantExp: "",
    CurrentEmployment: "",
    Adharcard: "",
    Pancard: "",
    Cost: "",
    CurrentLocation: "",
    PreferredLocation: "",
    BillingFrom: "",
    IsInActive:"",
    ReadyForBGV: "",
    Resume: "",
    Remarks: "",
    status: "",
    currency: "",
    Vendor: id,
    Frequency: "",
    // FirstName: "",
    lines: [],
  };
  const navigate = useNavigate();



  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Add Contractor"))
  }, [])
  const [formData, setFormData] = useState(initialFormData);
  const [subContractorGetData, setSubContractorGetData] = useState([]);
  const [genderOptions, setGenderOptions] = useState([]);
  const [skillSetOptions, setSkillSetOptions] = useState([]);
  const [subSkillOption, setSubSkillOptions] = useState([]);
  const [subSkillOption1, setSubSkillOptions1] = useState([]);
  const [frequencyOptions, setFrequencyOptions] = useState([]);
  const [technologyListOptions, setTechnologyListOptions] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [romPocOptions, setRomPocOptions] = useState([]);
  const [resNameOptions, setResNameOptions] = useState([]);
  const [jobTitleOptions, setJobTitleOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
 const [resumeFile, setResumeFile] = useState([]);

  const [fileName, setFileName] = useState();

  useEffect(() => {
    fetchSubContractor();
  }, []);

  const fetchSubContractor = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}sub-contractor?P_Id=${0}`
      );
      if (response.status === 200) {
        const cleanedData = response?.data?.data;
        setSubContractorGetData(cleanedData.headers);

        const genderOptions = cleanedData.gender.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setGenderOptions(genderOptions);

        const skillSetOptions = cleanedData.skillset.map((record) => ({
          value: record.ID,
          label: record.Name,
        }));
        setSkillSetOptions(skillSetOptions);

        const subskillOptions = cleanedData.sub_skills.map((record) => ({
          value: record.ID,
          label: record.SubSkill,
        }));
        setSubSkillOptions(subskillOptions);

        const frequencyOptions = cleanedData.frequency.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setFrequencyOptions(frequencyOptions);

        const technologyListOptions = cleanedData.technologylist.map(
          (record) => ({
            value: record.value,
            label: record.text,
          })
        );
        setTechnologyListOptions(technologyListOptions);

        const currencyOptions = cleanedData.currency.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setCurrencyOptions(currencyOptions);

        const romPocOptions = cleanedData.rompoc.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setRomPocOptions(romPocOptions);

        const resNameOptions = cleanedData.resname.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setResNameOptions(resNameOptions);

        const jobTitleOptions = cleanedData.jobtitle.map((record) => ({
          value: record.value,
          label: record.text,
        }));
        setJobTitleOptions(jobTitleOptions);

        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };


  const handleAddLine = () => {
    const currentRow =
      formData.lines.length !== 0
        ? formData.lines[formData.lines.length - 1]
        : null;

    const newLineNo = formData.lines.length + 1;

    if (currentRow && currentRow.ResName === "") {
      toast.error("Please fill in the current row.", {
        position: "top-right",
      });
      return;
    }

    setFormData((prevState) => ({
      ...prevState,
      lines: [
        ...prevState.lines, // Spread the existing lines
        {
          LineNo: newLineNo,
          ResName: "",
          ResCost: "",
          ResCurrency: "",
          ResFrequency: "",
          ResRole: "",
          ResTechnology: "",
          ResStartDate: "",
          ResActualEndDate: "",
          ResPayTerm: "",
          ResRemarks: "",
          ResLocation: "",
          SubcontractorID: "",
        },
      ],
    }));
  };



  useEffect(() => {
    if (formData.SkillID && formData.SkillID.length > 0) {
      // Extract the 'value' from each selected option
      const selectedValues = formData.SkillID.map(option => option?.value);

      // Join the selected values into a comma-separated string
      const skillValues = selectedValues.join(',');
      // Fetch sub-skill options with the comma-separated values
      fetchSubSkillOptions(skillValues);
    }
  }, [formData.SkillID]); // Dependency array will ensure this effect runs when SkillID changes

  const fetchSubSkillOptions = async (skill_id) => {
    try {
      let data = { skillId: skill_id };
      const response = await PostServiceCaller(
        API_URL + "fetch-subskils",
        data,
        "post"
      );
      const subSkillData = response.data;
      const options = subSkillData.map((subSkill) => ({
        value: subSkill.ID,
        label: subSkill.SubSkill,
      }));
      // options.push(...formData.SubSkillSet);
      setSubSkillOptions1(options);
    } catch (error) {
      console.error("Error fetching subSkill options:", error);
    }
  };

const [selectedFile, setSelectedFile] = useState(null);


  const handleFile = (file) => {
    if (file) {
      // Clear any previous error messages
      setErrors((prevErrors) => ({
        ...prevErrors,
        Resume: "",
      }));
 setSelectedFile(file);
      // Update form data and resume file state
      setFileName(file.name);
      setFormData((prevState) => ({
        ...prevState,
        Resume: file,
      }));
      setResumeFile(file);
    } else {
      // Set an error message if file is invalid
      setErrors((prevErrors) => ({
        ...prevErrors,
        Resume: "File size should not exceed 1MB and must be a PDF or Word document.",
      }));
    }
  };



  const schema = Yup.object().shape({
    FirstName: Yup.string()
      .required("First Name is required")
      .max(50, "First Name cannot exceed 50 characters"),
    LastName: Yup.string()
      .required("Last Name is required")
      .max(50, "Last Name cannot exceed 50 characters"),
    Title: Yup.string().required("Type is required"),
    TotalExp: Yup.number()
      .typeError("TotalExp must be a valid number")
      .required("TotalExp is required"),
    Role: Yup.string(),
    Phone: Yup.string(),
    CurrentLocation: Yup.string(),
    Resume: Yup.string().required("Resume is required"),
    Email: Yup.string()
      .email("Please enter a valid email address")
      .required("Email ID is required"),
    CurrentEmployment: Yup.mixed(),
    RelevantExp: Yup.mixed(),
    PreferredLocation: Yup.string(),
    ReadyForBGV: Yup.string(),
    BillingFrom: Yup.string(),
    IsInActive: Yup.string(),
    Adharcard: Yup.mixed(),
    Pancard: Yup.mixed(),
    Remarks: Yup.mixed(),
    Cost: Yup.number()
      .typeError("Cost must be a valid number")
      .required("Cost is required"),
    Gender: Yup.mixed(),
    SkillID: Yup.array()
      .required("Skill is required")
      .min(1, "Skill is required"),
    SubSkillID: Yup.array()
      .required("Sub Skill is required")
      .min(1, "Sub Skill is required"),
    lines: Yup.array().of(
      Yup.object().shape({
        LineNo: Yup.number().required("Line number is required"),
        ResName: Yup.string(),
        ResCost: Yup.string(),
        ResPayTerm: Yup.string(),
        ResRemarks: Yup.string(),
        ResLocation: Yup.string(),
        ResCurrency: Yup.string(),
      })
    ),
  });
  const validateField = async (fieldName, updatedData) => {
    try {
      // Validate the specific field
      await schema.validateAt(fieldName, updatedData);

      // Clear the error for the specific field if validation is successful
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: undefined }));
    } catch (err) {
      if (err.path === fieldName) {
        // Update the error only for the specific field
        setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: err.message }));

        // Show error using toast for specific fields if needed
        if (fieldName.startsWith("lines")) {
          toast.error(err.message, { position: "top-right" });
        }
      } else {
        console.error("Validation error structure is not as expected:", err);
      }
    }
  };
  const handleSelectChange = async (selectedOption, index, name) => {


    const updatedLines = [...formData.lines];
    updatedLines[index] = {
      ...updatedLines[index],
      [name]: selectedOption.value,
    };

    const updatedFormData = { ...formData, lines: updatedLines };
    setFormData(updatedFormData);

    // Validate the specific field in the 'lines' array
    await validateField(`lines[${index}].${name}`, updatedFormData);
  };


  const handleSelect = async (selectedOption, name) => {
    
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: selectedOption.value };
      validateField(name, updatedData);
      return updatedData;
    });
  };
  const handleMultiSelect = async (selectedOption, name) => {
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: selectedOption };
      validateField(name, updatedData);
      return updatedData;
    });
  };


  const handleContractorChange = async (e) => {
    const { name, value } = e.target;
    if (schema.fields[name]) {
      setFormData((prevData) => {
        const updatedData = { ...prevData, [name]: value };
        validateField(name, updatedData); // Validate only the specific field
        return updatedData;
      });
    }
  }


  // Validate full form and save all errors
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await schema.validate(formData, { abortEarly: false });
      setErrors({}); 


      const response = await PostFormServiceCaller(
        `${API_URL}sub-contractor`,
        {
          ...formData,
          FullName: `${formData.FirstName} ${formData.LastName}`
        },
        "post"
      );

      if (response.status === 200) {
        toast.success("Data submitted successfully");
        setTimeout(() => {
          window.location.href = "/contractors";
        }, 2000);
      } else {
        console.error("Failed to submit data. Server responded with status:", response.status);
      }
    } catch (error) {
      if (error.name === "ValidationError") {
        console.error("Validation Error:", error);
        const validationErrors = {};
        error.inner.forEach((err) => {
          validationErrors[err.path] = err.message;
        });
        setErrors(validationErrors);

        // Display validation errors related to the 'lines' field using toast
        Object.keys(validationErrors).forEach((field) => {
          // Check if the error is related to 'lines' field
          if (field.startsWith('lines')) {
            toast.error(validationErrors[field], { position: "top-right" });
          }
        });
      } else {
        console.error("Unexpected Error:", error);
      }
    } finally {
      setLoading(false);
    }
  };






  const handleChange = async (e, index) => {
    const { name, type, checked, value } = e.target;
    const updatedLines = [...formData.lines];
    const newValue = type === "checkbox" ? checked : value;

    updatedLines[index] = {
      ...updatedLines[index],
      [name]: newValue,
    };

    setFormData((prevState) => ({
      ...prevState,
      lines: updatedLines,
    }));

    if (schema.fields[name]) {
      await validateField(name, updatedLines[index]);
    }
  };

  const handleResDateChange = (event, index) => {
    const { name, value } = event.target;
    const updatedLines = [...formData.lines];
    updatedLines[index] = {
      ...updatedLines[index],
      [name]: value,
    };

    setFormData((prevState) => ({
      ...prevState,
      lines: updatedLines,
    }));
  };
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);


  const openDeleteModal = (item) => {

    setShowDeleteModal(true);
    setSelectedDeleteItem(item);

  };
  const handleModalDelete = () => {
    if (selectedDeleteItem) {

      handleDeletePOCLine(selectedDeleteItem.index,);

      setShowDeleteModal(false);
    }
  };
  const handleDeletePOCLine = async (index) => {

    const updatedLines = formData.lines.filter((_, i) => i !== index);
    setFormData((prevState) => ({
      ...prevState,
      lines: updatedLines,
    }));
  };
  const handleDeleteClose = () => {
    setShowDeleteModal(false);
    setSelectedDeleteItem(null);

  };
  return (
    <>
     <div className="Container">

        <form
          id="formOne"
          className="rounded bg-white mt-2"
        // onSubmit={handleSubmit}
        >
          <ul className="nav nav-tabs" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="contractorDetails-tab"
                data-bs-toggle="tab"
                data-bs-target="#contractorDetails"
                type="button"
                role="tab"
                style={{ color: "#2F2E4B" }}
                aria-controls="contractorDetails"
                aria-selected="true"
              >
                Contractor Details<span className="text-Primary">{formData.FirstName?.trim() && `: ${formData.FirstName}`}</span>
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="addProject-tab"
                data-bs-toggle="tab"
                data-bs-target="#addProject"
                type="button"
                style={{ color: "#2F2E4B" }}
                role="tab"
                aria-controls="addProject"
                aria-selected="false"
              >
                Add Project
              </button>
            </li>
          </ul>

          <div
            className="tab-content"
            id="myTabContent"
            aria-orientation="vertical"
          >
            {/** Contarctor Code start */}
            <div
              className="tab-pane fade show active"
              id="contractorDetails"
              role="tabpanel"
              aria-labelledby="contractorDetails-tab"
            >
              <div className="p-2">
                <div class="card-body  mx-2">
                  <div className="row row-flex p-2">
                    {/* grid one */}
                    <div className="col-md-12 flex-col mt-1">
                      <div className=" ">
                        <div className="row">
                          <div className="col-md-12">
                            <label className="form-label me-2">Type<span className="text-danger me-2">*</span></label>
                            <input
                              type="radio"
                              className={`form-check-input me-2 ${errors.Title ? "error" : ""
                                }`}
                              name="Title"
                              // onChange={handleContractorType}
                              onChange={(e) => handleContractorChange(e)}
                              value="FreeLancer"
                            />
                            <span className="me-2">FreeLancer</span>
                            <input
                              type="radio"
                              className={`form-check-input me-2 ${errors.Title ? "error" : ""
                                }`}
                              name="Title"
                              onChange={(e) => handleContractorChange(e)}
                              value="SubContractor"
                            />
                            <span>SubContractor</span>
                            {errors.Title && (
                              <div className="error">
                                {errors.Title}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-md-3">
                            <label className="form-label">
                              First Name
                              <span className="text-danger me-2">*</span>
                            </label>

                            <input
                              name="FirstName"
                              type="text"
                              className={`form-control ${errors.FirstName ? "is-invalid" : ""
                                }`}
                              id="FirstName"
                              value={formData.FirstName}
                              // onChange={(e) => handleFName(e)}
                              onChange={(e) => handleContractorChange(e)}
                            />
                            {errors.FirstName && (
                              <div className="invalid-feedback">
                                {errors.FirstName}
                              </div>
                            )}
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">
                              Last Name
                              <span className="text-danger me-2">*</span>
                            </label>

                            <input
                              name="LastName"
                              type="text"
                              className={`form-control ${errors.LastName ? "is-invalid" : ""
                                }`}
                              id="LastName"
                              value={formData.LastName}
                              // onChange={(e) => handleLName(e)}
                              onChange={(e) => handleContractorChange(e)}
                            />
                            {errors.LastName && (
                              <div className="invalid-feedback">
                                {errors.LastName}
                              </div>
                            )}
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">Gender</label>
                            <Select
                              name="Gender"
                              // onChange={(gender) =>
                              //   setGenderValue(gender.value)
                              // }
                              onChange={(selectedOption, action) =>
                                handleSelect(selectedOption, action.name)
                              }
                              value={genderOptions.label}
                              // className="form-control"
                              options={[
                                { value: "", label: "Select" },
                                ...genderOptions,
                              ]}
                            />
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">Contact No.</label>
                            <input
                            type="text"
                              // defaultCountry="in"
                              className="form-control"
                              name="Phone"
                              // rules={{ required: true }}
                              value={formData.Phone}
                              onChange={(e) => handleContractorChange(e)}
                            />
                          </div>
                        </div>

                        <div className="row mt-2">
                          <div className="col-md-3">
                            <label className="form-label">
                              Email ID
                              <span className="text-danger me-2">*</span>
                            </label>
                            <input
                              type="email"
                              name="Email"
                              className={`form-control ${errors.Email ? "is-invalid" : ""
                                }`}
                              // onChange={handleEmail}
                              onChange={(e) => handleContractorChange(e)}
                              value={formData.Email}
                            />
                            {errors.Email && (
                              <div className="invalid-feedback">
                                {errors.Email}
                              </div>
                            )}
                          </div>

                          <div className="col-md-3">
                            <label className="form-label">
                              Current Location
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="CurrentLocation"
                              // onChange={handleCurentLocation}
                              onChange={(e) => handleContractorChange(e)}
                              value={formData.CurrentLocation}
                            />
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">
                              Preferred Location
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="PreferredLocation"
                              // onChange={handlePreferredLoc}
                              onChange={(e) => handleContractorChange(e)}
                              value={formData.PreferredLocation}
                            />
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">Role</label>
                            <input
                              type="text"
                              className="form-control"
                              name="Role"
                              // onChange={handleRole}
                              onChange={(e) => handleContractorChange(e)}
                              value={formData.Role}
                            />
                          </div>

                        </div>

                        <div className="row mt-2">
                          <div className="col-md-3">
                            <label className="form-label">Current Emp.</label>
                            <input
                              type="number"
                              className="form-control text-end"
                              name="CurrentEmployment"
                              // onChange={handleCurrentEmpl}
                              onChange={(e) => handleContractorChange(e)}
                              value={formData.CurrentEmployment}
                              placeholder="in Yrs"
                            />
                          </div>
                          <div className="col-md-3 d-flex">
                            <div className="d-flex flex-column">
                              <label className="form-label">Experience<span className="text-danger me-2">*</span></label>
                              <div className="row">
                                <div className="col-md-6">
                                  <input
                                    type="text"
                                    className={`form-control text-end ${errors.TotalExp ? "is-invalid" : ""
                                      }`}
                                    placeholder="TotalExp in Yrs"
                                    name="TotalExp"
                                    // onChange={handleTotalExp}
                                    onChange={(e) =>
                                      handleContractorChange(e)
                                    }
                                    value={formData.TotalExp}
                                  />
                                  {errors.TotalExp && (
                                    <div className="invalid-feedback">
                                      {errors.TotalExp}
                                    </div>
                                  )}
                                </div>
                                <div className="col-md-6">
                                  <input
                                    type="number"
                                    className="form-control text-end"
                                    name="RelevantExp"
                                    placeholder="ReleExp in Yrs"
                                    // onChange={handleRelevantExp}
                                    onChange={(e) =>
                                      handleContractorChange(e)
                                    }
                                    value={formData.RelevantExp}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-md-3">
                            <label className="form-label">
                              Cost<span className="text-danger me-2">*</span>
                            </label>
                            <input
                              type="number"
                              className={`form-control text-end ${errors.Cost ? "is-invalid" : ""
                                }`}
                              name="Cost"
                              // onChange={handleCost}
                              onChange={(e) => handleContractorChange(e)}
                              value={formData.Cost}
                            />

                            {errors.Cost && (
                              <div className="invalid-feedback">
                                {errors.Cost}
                              </div>
                            )}
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">Frequency</label>
                            <Select
                              name="Frequency"
                              // onChange={handleRomPoc}
                              // onChange={(frequency) =>
                              //   setFrequency(frequency.value)
                              // }
                              onChange={(selectedOption, action) =>
                                handleSelect(selectedOption, action.name)
                              }
                              value={frequencyOptions.find(
                                (option) => option.value === formData.value
                              )}
                              // className="form-control"
                              options={[
                                { value: "", label: "Select" },
                                ...frequencyOptions,
                              ]}
                            />
                          </div>

                        </div>

                        {/** Type Code Start */}

                        <div className="row mt-2">
                          <div className="col-md-3">
                            <label className="form-label">RMG POC</label>
                            <Select
                              name="RomPoc"
                              // onChange={handleRomPoc}
                              // onChange={(rompoc) =>
                              //   setRomPocValue(rompoc.value)
                              // }
                              onChange={(selectedOption, action) =>
                                handleSelect(selectedOption, action.name)
                              }
                              value={romPocOptions.label}
                              // className="form-control"
                              options={[
                                { value: "", label: "Select" },
                                ...romPocOptions,
                              ]}
                            />
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">Currency</label>
                            <Select
                              name="currency"
                              // onChange={(currency) =>
                              //   setCurrency(currency.value)
                              // }
                              onChange={(selectedOption, action) =>
                                handleSelect(selectedOption, action.name)
                              }
                              value={currencyOptions.find(
                                (option) => option.value === formData.currency
                              )}
                              options={[
                                { value: "", label: "Select" },
                                ...currencyOptions,
                              ]}
                            />
                          </div>
                          {/* <div className="col-md-3">
                            <label className="form-label">ROM POC</label>
                            <Select
                              name="RomPoc"
                              // onChange={handleRomPoc}
                              // onChange={(rompoc) =>
                              //   setRomPocValue(rompoc.value)
                              // }
                              onChange={(selectedOption, action) =>
                                handleSelect(selectedOption, action.name)
                              }
                              value={romPocOptions.label}
                              // className="form-control"
                              options={[
                                { value: "", label: "Select" },
                                ...romPocOptions,
                              ]}
                            />
                          </div> */}
                          <div className="col-md-3">
                            <label className="form-label">Aadhar No.</label>
                            <input
                              type="text"
                              className={`form-control ${errors.Adharcard ? "is-invalid" : ""
                                }`}
                              name="Adharcard"
                              placeholder="Eg: 0000 0000 0000"
                              value={formData.Adharcard}
                              onChange={(e) => handleContractorChange(e)}
                            // onChange={handleAadhar}
                            // Directly pass the function
                            />
                            {errors.Adharcard && (
                              <div className="invalid-feedback">
                                {errors.Adharcard}
                              </div>
                            )}
                          </div>

                          <div className="col-md-3">
                            <label className="form-label">PAN No.</label>
                            <input
                              type="text"
                              className={`form-control ${errors.Pancard ? "is-invalid" : ""
                                }`}
                              name="Pancard"
                              placeholder="Eg: AAAAA9999A"
                              value={formData.Pancard}
                              // onChange={(e) => handlePanCard(e)}
                              onChange={(e) => handleContractorChange(e)}
                            />
                            {errors.Pancard && (
                              <div className="invalid-feedback">
                                {errors.Pancard}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-md-3">
                            <label className="form-label">
                              Skill
                              <span className="text-danger me-2">*</span>
                            </label>
                            <Select
                              menuShouldScrollIntoView={true}
                              isMulti
                              name="SkillID"
                              options={[
                                { value: "", label: "Select" },
                                ...skillSetOptions,
                              ]}
                              className={`basic-multi-select
                             ${errors.SkillID ? "is-invalid" : ""}`}
                              classNamePrefix="select"
                              // onChange={handleSkillChange}
                              onChange={(selectedOption, action) =>
                                handleMultiSelect(selectedOption, action.name)
                              }
                              styles={customStyle}
                            />
                            {errors.SkillID && (
                              <div className="invalid-feedback">
                                {errors.SkillID}
                              </div>
                            )}
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">SubSkill<span className="text-danger me-2">*</span></label>
                            <Select
                              isMulti
                              name="SubSkillID"
                              options={[
                                { value: "", label: "Select" },
                                ...subSkillOption1,
                              ]}
                              className={`basic-multi-select
                                  ${errors.SubSkillID ? "is-invalid" : ""}`}
                              classNamePrefix="select"
                              // onChange={handleSubSkillChange}
                              onChange={(selectedOption, action) =>
                                handleMultiSelect(selectedOption, action.name)
                              }
                              styles={customStyle}
                            /> {errors.SubSkillID && (
                              <div className="invalid-feedback">
                                {errors.SubSkillID}
                              </div>
                            )}
                          </div>
                          <div className="col-md-3 ">
                            <label className="form-label">Remark</label>
                            <textarea
                              placeholder="Remark"
                              className={`form-control`}
                              name="Remarks"
                              // onChange={handleRemark}
                              onChange={(e) => handleContractorChange(e)}
                              value={formData.Remarks}
                            ></textarea>
                          </div>

                          <div className="col-md-3 ">
                            <label className="form-label">
                              Ready For BGV.
                            </label>
                            <div className="ms-2">
                              <input
                                type="radio"
                                className="form-check-input me-2"
                                name="ReadyForBGV"
                                // onChange={handleBGV}
                                onChange={(e) => handleContractorChange(e)}
                                value="1"
                              />
                              <span className="me-2">Yes</span>
                              <input
                                type="radio"
                                className="form-check-input me-2"
                                name="ReadyForBGV"
                                // onChange={handleBGV}
                                onChange={(e) => handleContractorChange(e)}
                                value="0"
                              />
                              <span>No</span>
                            </div>
                          </div>
                        </div>

                        <div className="row mt-2">
                          <div className="col-md-3">
                            <label className="form-label">
                              Willing To Travel
                            </label>
                            <div className="ms-2">
                              <input
                                type="radio"
                                className="form-check-input me-2"
                                name="BillingFrom"
                                // onChange={handleWillingToTravel}
                                onChange={(e) => handleContractorChange(e)}
                                value="1"
                              />
                              <span className="me-2">Yes</span>
                              <input
                                type="radio"
                                className="form-check-input me-2"
                                name="BillingFrom"
                                // onChange={handleWillingToTravel}
                                onChange={(e) => handleContractorChange(e)}
                                value="0"
                              />
                              <span>No</span>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <label className="form-label">Resume<span className="text-danger me-2">*</span></label>
                            <div className="d-flex">
                              <div>
                                <div>
                                  <FileUploader handleFile={handleFile} />
                                </div>
                                <span>
                                  {errors.Resume && (
                                    <div className="error">
                                      {errors.Resume}
                                    </div>
                                  )}
                                  {fileName && selectedFile && (
  <div className="m-2">
    <p>Resume:
    <a
      href={URL.createObjectURL(selectedFile)}
      target="_blank"
      rel="noopener noreferrer"
      className="ms-2 text-decoration-none"
      // className="btn btn-outline-primary btn-sm"
    >
     {fileName}
    </a> </p>
  </div>
)}

                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">
                              Active
                            </label>
                            <div className="ms-2">
                              <input
                                type="radio"
                                className="form-check-input me-2"
                                name="IsInActive"
                                // onChange={handleWillingToTravel}
                                onChange={(e) => handleContractorChange(e)}
                                value="0"
                              />
                              <span className="me-2">Yes</span>
                              <input
                                type="radio"
                                className="form-check-input me-2"
                                name="IsInActive"
                                // onChange={handleWillingToTravel}
                                onChange={(e) => handleContractorChange(e)}
                                value="1"
                              />
                              <span>No</span>
                            </div>
                          </div>
                        </div>
                        {/** Input Code Start */}

                        {/** Input Code End */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/** Contarctor Code end */}

            {/** Line LEvel Code start */}
            <div
              className="tab-pane fade"
              id="addProject"
              role="tabpanel"
              aria-labelledby="addProject-tab"
            >
              <div
                className="mt-2 mb-3"
                style={{ zIndex: "-999 !important" }}
              >
                <div className=" ">
                  <div className="">
                    <div className="table-responsive poc-head rounded px-2">
                      <button
                        type="button"
                        onClick={handleAddLine}
                        className="custom-btn-sm mb-1 pull-right"
                      >
                        <i className="fa fa-plus"></i>&nbsp;Add
                      </button>
                      <Table
                        style={{ background: "#ECECEC !important" }}
                        className="table table-bordered"
                      >
                        <thead id="thcolor" className="text-center">
                          <tr rowspan="2">
                            <th className="align-middle">Sr.No</th>
                            <th
                              className="border-1 px-0 
                            fs-10"
                            >
                              <div className="border-1 border-bottom">
                                Client Name{" "}
                                {/* <span className="text-danger me-2">*</span> */}
                              </div>
                              <div>Start Date</div>
                            </th>

                            <th className="border-1 px-0 fs-9">
                              <div className="border-1 border-bottom">
                                PO Cost
                              </div>
                              <div>End Date</div>
                            </th>
                            <th className="border-1 px-0 fs-9">
                              <div className="border-1 border-bottom">
                                Frequency
                              </div>
                              <div>Actual End Date </div>
                            </th>
                            <th className="border-1 px-0 fs-9">
                              <div className="border-1 border-bottom">
                                Currency
                                {/* <span className="text-danger me-2">*</span> */}

                              </div>
                              <div>Pay Term</div>
                            </th>
                            <th className="border-1 px-0 fs-9">
                              <div className="border-1 border-bottom">
                                Role
                              </div>
                              <div>Remark</div>
                            </th>
                            <th className="border-1 px-0 fs-9">
                              <div className="border-1 border-bottom">
                                Technology
                              </div>
                              <div>Location</div>
                            </th>
                            <th className="align-middle fs-9">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {formData.lines.map((line, index) => (
                            <tr key={index} className="bg-white" rowspan="2">
                              <td className="align-middle text-center">
                                {index + 1}
                              </td>
                              <td>
                                <div>
                                  <Select
                                    name="ResName"
                                    onChange={(selectedOption) =>
                                      handleSelectChange(
                                        selectedOption,
                                        index,
                                        "ResName"
                                      )
                                    }
                                    // className={` ${errors?.[`lines[${index}].ResName`]
                                    //   ? "is-invalid"
                                    //   : ""
                                    //   }`}
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    // menuPlacement="top"
                                    value={resNameOptions.find(
                                      (option) =>
                                        option.value === line.ResName
                                    )}
                                    options={[
                                      { value: "", label: "Select" },
                                      ...resNameOptions,
                                    ]}
                                  />
                                  {/* {errors?.[`lines[${index}].ResName`] ? <span className="error">
                                    {errors?.[`lines[${index}].ResName`]}
                                  </span> : ''} */}
                                </div>
                                <div className="mt-1">
                                  <CustomDatePicker
                                    handleChange={(e) =>
                                      handleResDateChange(e, index)
                                    }
                                    name="ResStartDate"
                                    id="ResStartDate"
                                    className="form-control"
                                    value={line.ResStartDate}
                                    placeholderText="DD-MM-YYYY"
                                  />
                                </div>
                              </td>
                              <td>
                                <div>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="ResCost"
                                    value={line.ResCost}
                                    onChange={(e) => handleChange(e, index)}
                                  />
                                </div>
                                <div className="mt-1">
                                  <CustomDatePicker
                                    handleChange={(e) =>
                                      handleResDateChange(e, index)
                                    }
                                    name="ResEndDate"
                                    id="ResEndDate"
                                    className="form-control"
                                    value={line.ResEndDate}
                                    placeholderText="DD-MM-YYYY"
                                    minDate={new Date(line.ResStartDate)}
                                  />
                                </div>
                              </td>
                              <td>
                                <div>
                                  <Select
                                    name="ResFrequency"
                                    onChange={(selectedOption) =>
                                      handleSelectChange(
                                        selectedOption,
                                        index,
                                        "ResFrequency"
                                      )
                                    }
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    // menuPlacement="top"
                                    value={frequencyOptions.find(
                                      (option) =>
                                        option.value === line.ResFrequency
                                    )}
                                    options={[
                                      { value: "", label: "Select" },
                                      ...frequencyOptions,
                                    ]}
                                  />
                                </div>
                                <div className="mt-1">
                                  <CustomDatePicker
                                    handleChange={(e) =>
                                      handleResDateChange(e, index)
                                    }
                                    name="ResActualEndDate"
                                    id="ResActualEndDate"
                                    className="form-control"
                                    value={line.ResActualEndDate}
                                    placeholderText="DD-MMM-YYYY"
                                    minDate={new Date(line.ResStartDate)}
                                  />
                                </div>
                              </td>
                              <td>
                                <div>
                                  <Select
                                    name="ResCurrency"
                                    onChange={(selectedOption) =>
                                      handleSelectChange(
                                        selectedOption,
                                        index,
                                        "ResCurrency"
                                      )
                                    }
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    // menuPlacement="top"
                                    value={currencyOptions.find(
                                      (option) =>
                                        option.value === line.ResCurrency
                                    )}
                                    // className={` ${errors?.[`lines[${index}].ResCurrency`]
                                    //   ? "is-invalid"
                                    //   : ""
                                    //   }`}
                                    options={[
                                      { value: "", label: "Select" },
                                      ...currencyOptions,
                                    ]}
                                  />
                                  {/* {errors?.[`lines[${index}].ResCurrency`] ? <span className="error">
                                    {errors?.[`lines[${index}].ResCurrency`]}
                                  </span> : ''} */}
                                </div>
                                <div className="mt-1">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="ResPayTerm"
                                    onChange={(e) => handleChange(e, index)}
                                    value={line.ResPayTerm}
                                  />
                                </div>
                              </td>
                              <td>
                                <div>
                                  <Select
                                    name="ResRole"
                                    onChange={(selectedOption) =>
                                      handleSelectChange(
                                        selectedOption,
                                        index,
                                        "ResRole"
                                      )
                                    }
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    // menuPlacement="top"
                                    value={jobTitleOptions.find(
                                      (option) =>
                                        option.value === line.ResRole
                                    )}
                                    options={[
                                      { value: "", label: "Select" },
                                      ...jobTitleOptions,
                                    ]}
                                  />
                                </div>
                                <div className="mt-1">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="ResRemarks"
                                    onChange={(e) => handleChange(e, index)}
                                    value={line.ResRemarks}
                                  />
                                </div>
                              </td>
                              <td>
                                <div>
                                  <Select
                                    name="ResTechnology"
                                    onChange={(selectedOption) =>
                                      handleSelectChange(
                                        selectedOption,
                                        index,
                                        "ResTechnology"
                                      )
                                    }
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                    // menuPlacement="top"
                                    value={technologyListOptions.find(
                                      (option) =>
                                        option.value === line.ResTechnology
                                    )}
                                    options={[
                                      { value: "", label: "Select" },
                                      ...technologyListOptions,
                                    ]}
                                  />
                                </div>
                                <div className="mt-1">
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="ResLocation"
                                    onChange={(e) => handleChange(e, index)}
                                    value={line.ResLocation}
                                  />
                                </div>
                              </td>
                              <td className="text-center align-middle">
                                <div
                                  type="button"
                                  // onClick={(e) => handleDeleteLine(e, index)}
                                  onClick={() => openDeleteModal({ index })}
                                >
                                  <i
                                    className="bi bi-trash"
                                    style={{ fontSize: "1.2rem" }}
                                  ></i>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/** Line LEvel Code end */}
          </div>

          {/* button code start*/}

          <div className="pb-2 ">
            <div className="text-end me-2">
              <button
                type="button"
                className="cancel-btn me-2"
                onClick={() => {
                  navigate("/partner-master");
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                disabled={loading ? true : false}
                className="custom-btn me-2"
                onClick={handleSubmit}
              >
                {loading ? <FaSpinner class="sm-spinner" /> : "Submit"}
              </button>
            </div>
          </div>
          {/* button code end*/}
        </form>
      </div>
      <DeleteModal
        show={showDeleteModal}
        onClose={handleDeleteClose}
        onConfirm={handleModalDelete}
        message="Are you sure you want to delete this item?"
      />

    </>
  );
};

export default AddContractor;
